module.exports = __webpack_public_path__ + "display_mode.410091178e47027dcce9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/display_mode.svg
// module id = ./src/assets/img/display_mode.svg
// module chunks = main